export default __webpack_public_path__ + "static/media/banco-carrefour.cdb333de.png";